import _ from 'lodash';
import { TagLegal as PtTagLegal } from 'patsnap-biz';
export const name = 'SIMPLE_LEGAL_STATUS.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const cellValue = _.get(row, prop);
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {!_.isNil(cellValue) && cellValue !== '' ? <PtTagLegal simple={true} code={cellValue}/> : null}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
